const _defTypes = ['REQUEST', 'SUCCESS', 'FAILURE']
const _makeTypes = (base, types = [], extra = []) => {
  return types.concat(_defTypes).concat(extra).reduce((obj, type) => {
    obj[type] = `${base}_${type}`
    return obj
  }, {})
}

export const LOGIN = _makeTypes('LOGIN', ['CHECK'])
export const LOGOUT = 'LOGOUT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js